import React, { useEffect, useState } from 'react';
import { Plus, Search, Edit3, ScrollText, MessageSquare, Save, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import api from '../services/api';
import IconButton from '../components/IconButton';

const Convencao = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  
  const [isSaving, setIsSaving] = useState(false);
  const [obsModalItem, setObsModalItem] = useState(null);

  const [formData, setFormData] = useState({
    descricao_conv: '',
    ativo_conv: '',
    obs_conv: ''
  });

  useEffect(() => { document.title = 'Convenção - EstOX'; }, []);
  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const response = await api.get('/convencao');
      setItems(response.data.data || []);
    } catch (error) {
      console.error('Erro ao carregar convenções:', error);
      toast.error('Erro ao carregar convenções');
    } finally {
      setLoading(false);
    }
  };

  const filtered = items.filter(i => (
    String(i.descricao_conv ?? '').toLowerCase().includes(String(searchTerm).toLowerCase()) ||
    String(i.obs_conv ?? '').toLowerCase().includes(String(searchTerm).toLowerCase())
  ));

  const openModal = (item = null) => {
    setEditingItem(item);
    setFormData({
      descricao_conv: item?.descricao_conv || '',
      ativo_conv: item?.ativo_conv ?? '',
      obs_conv: item?.obs_conv || ''
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setFormData({ descricao_conv: '', ativo_conv: '', obs_conv: '' });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!formData.descricao_conv.trim()) {
      toast.error('Descrição é obrigatória');
      return;
    }
    setIsSaving(true);
    try {
      if (editingItem) {
        await api.put(`/convencao/${editingItem.id}`, formData);
        toast.success('Convenção atualizada com sucesso!');
      } else {
        await api.post('/convencao', formData);
        toast.success('Convenção criada com sucesso!');
      }
      closeModal();
      load();
    } catch (error) {
      console.error('Erro ao salvar convenção:', error);
      toast.error('Erro ao salvar convenção');
    } finally {
      setIsSaving(false);
    }
  };

  

  const renderStatus = (v) => {
    const n = (v === '' || v === null || v === undefined) ? null : Number(v);
    if (n === 1) return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">ATIVO</span>;
    if (n === 0) return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">INATIVO</span>;
    return '-';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Convenção</h1>
        <p className="text-gray-600">Gerencie convenções do sistema</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <ScrollText className="h-8 w-8 text-blue-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total de Convenções</p>
              <p className="text-2xl font-bold text-gray-900">{items.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <Search className="h-8 w-8 text-green-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Filtradas</p>
              <p className="text-2xl font-bold text-gray-900">{filtered.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <Plus className="h-8 w-8 text-purple-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Ações</p>
              <IconButton icon={Plus} onClick={() => openModal()} variant="primary" title="Nova Convenção" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                <input
                  type="text"
                  placeholder="Buscar convenções..."
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <IconButton icon={Plus} onClick={() => openModal()} variant="primary" title="Nova Convenção" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ativo</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Obs.</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-900">{item.id}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{item.descricao_conv || '-'}</td>
                  <td className="px-6 py-4 text-sm text-gray-900">{renderStatus(item.ativo_conv)}</td>
                  <td className="px-6 py-4">
                    <IconButton
                      icon={MessageSquare}
                      onClick={() => setObsModalItem(item)}
                      variant="info"
                      size="sm"
                      title={item.obs_conv && String(item.obs_conv).trim() ? 'Ver observação' : 'Sem observação'}
                      disabled={!(item.obs_conv && String(item.obs_conv).trim())}
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <IconButton icon={Edit3} onClick={() => openModal(item)} variant="warning" size="sm" title="Editar" />
                      
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {filtered.length === 0 && (
          <div className="text-center py-12">
            <ScrollText className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">Nenhuma convenção encontrada</h3>
            <p className="mt-1 text-sm text-gray-500">{searchTerm ? 'Tente ajustar sua busca.' : 'Comece criando uma nova convenção.'}</p>
          </div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-6 border w-full max-w-2xl shadow-lg rounded-lg bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">{editingItem ? 'Editar Convenção' : 'Nova Convenção'}</h3>
              <form onSubmit={handleSave} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Descrição *</label>
                  <input type="text" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={formData.descricao_conv} onChange={(e) => setFormData({ ...formData, descricao_conv: e.target.value })} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ativo</label>
                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    value={formData.ativo_conv}
                    onChange={(e) => setFormData({ ...formData, ativo_conv: e.target.value })}
                  >
                    <option value="">Selecione</option>
                    <option value="1">ATIVO</option>
                    <option value="0">INATIVO</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" rows="3" value={formData.obs_conv} onChange={(e) => setFormData({ ...formData, obs_conv: e.target.value })} />
                </div>
                <div className="flex justify-end space-x-3 pt-4">
                  <IconButton icon={X} onClick={closeModal} variant="secondary" title="Cancelar" />
                  <IconButton icon={Save} type="submit" disabled={isSaving} variant="primary" title={isSaving ? 'Salvando...' : (editingItem ? 'Atualizar' : 'Criar')} />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      

      {obsModalItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" onClick={() => setObsModalItem(null)}>
          <div className="relative top-20 mx-auto p-5 border w-full max-w-lg shadow-lg rounded-md bg-white" onClick={(e) => e.stopPropagation()}>
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Observação da Convenção #{obsModalItem.id}</h3>
              <div className="p-3 border border-gray-200 rounded bg-gray-50 whitespace-pre-wrap text-sm text-gray-800">
                {obsModalItem.obs_conv && String(obsModalItem.obs_conv).trim() ? obsModalItem.obs_conv : 'Sem observação.'}
              </div>
              <div className="mt-4 flex justify-end">
                <IconButton icon={X} onClick={() => setObsModalItem(null)} variant="secondary" title="Fechar" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Convencao;
